var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOnePressed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.894 10.062H29v2.189h2.894v2.655h2.399V12.25h2.894v-2.189h-2.894v-2.64h-2.399v2.64zM41.426 7.422V16H44V5h-4.301v2.422h1.727zM11 20.308l-1.595-1.44C3.74 13.669 0 10.293 0 6.088 0 2.656 2.64 0 6.05 0 7.975 0 9.79.885 11 2.324 12.21.885 14.025 0 15.95 0 19.36 0 22 2.656 22 6.087c0 4.205-3.74 7.58-9.405 12.782L11 20.308z",
    fill: "#fff"
  })));
}
export default SvgPlusOnePressed;